import React from 'react';

function PromoModal({ promo, onClose, showFilteredOnly, filteredItems }) {
    if (!promo) return null;

    // Determine which items to display
    const itemsToShow = (showFilteredOnly && filteredItems)
        ? filteredItems
        : promo.items;

    // Sort items alphabetically
    const sortedItems = [...itemsToShow].sort((a, b) =>
        a.item.localeCompare(b.item)
    );

    // Format dates for display
    const formatDate = (dateStr) => {
        const date = new Date(dateStr + 'T00:00:00');
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2 className="modal-title">{promo.name}</h2>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                <div className="modal-dates">
                    {formatDate(promo.startDate)} to {formatDate(promo.endDate)}
                    {showFilteredOnly && filteredItems && (
                        <span style={{ marginLeft: '10px', fontStyle: 'italic' }}>
                            (Showing filtered items only)
                        </span>
                    )}
                </div>
                <ul className="modal-items">
                    {sortedItems.map((item, idx) => (
                        <li key={idx} className="modal-item">
                            <span className="modal-item-name">{item.item}</span>
                            {item.discount != null && (
                                <span className="modal-item-discount">
                                    {(item.discount * 100).toFixed(0)}% off
                                </span>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default PromoModal;
